<div class="mapa-flotante">
  <app-flotante-emergencias-medicas
    [emergencias]="emergencias"
    [cantAmbulancias]="ambulancias.length"
    [cantHospitales]="hospitales.length"
    [cantBases]="bases.length"
    (emergenciasChange)="onEmergenciasFiltradas($event)"
    (capasChange)="onCapasChange($event)"
    (modoChange)="onModoChange($event)"
    [dona]="datosTorta.length ? dona : null"
  ></app-flotante-emergencias-medicas>
</div>

<!-- Dona del resumen: el panel la pone junto a los chips de Código o de
     Estados, según con qué se pinten las emergencias -->
<ng-template #dona>
  <app-pie-chart-emergencias
    class="mapa-dona"
    [datos]="datosTorta"
    [chartStyle]="'width: 96px; height: 96px; display: block'"
  ></app-pie-chart-emergencias>
</ng-template>

<app-mapa-facil-v2
  [zoom]="12"
  [style]="tipoMapaBase"
  [mapId]="'MapaEmergenciasMedicasComponent'"
  [mapasPersonalizados]="mapasPersonalizados"
  [allowedEntityTypes]="allowedTypes"
  (mapReady)="onMapReady($event)"
></app-mapa-facil-v2>
